module.exports = __webpack_public_path__ + "static/media/shrink2.2e08aa9f.svg";